import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "next-mdx-import-source-file";
export const metadata = {
  title: "Market Intelligence and Deep Research",
  published_at: "2026-07-15",
  summary: "Search companies, people, and current news in chat, then point Deep Research at hard questions for a cited report.",
  tags: ["AI", "Platform"],
  draft: false
};
export const sections = [{
  id: "company-intelligence",
  label: "Company intelligence"
}, {
  id: "people-intelligence",
  label: "People intelligence"
}, {
  id: "news-intelligence",
  label: "News intelligence"
}, {
  id: "deep-research",
  label: "Deep Research"
}, {
  id: "how-to-start",
  label: "How to start"
}];
function _createMdxContent(props) {
  const _components = {
    em: "em",
    h2: "h2",
    p: "p",
    strong: "strong",
    ..._provideComponents(),
    ...props.components
  }, {CompanyIntelligencePreview, DeepResearchPreview, NewsIntelligencePreview, PeopleIntelligencePreview} = _components;
  if (!CompanyIntelligencePreview) _missingMdxReference("CompanyIntelligencePreview", true);
  if (!DeepResearchPreview) _missingMdxReference("DeepResearchPreview", true);
  if (!NewsIntelligencePreview) _missingMdxReference("NewsIntelligencePreview", true);
  if (!PeopleIntelligencePreview) _missingMdxReference("PeopleIntelligencePreview", true);
  return _jsxs(_Fragment, {
    children: [_jsxs(_components.p, {
      children: ["Winning work starts with knowing who you're up against, who to call, and what changed. Chat can now search companies, people, and current news without making you jump between separate tools. When the question is bigger than a lookup, hand it to ", _jsx(_components.strong, {
        children: "Deep Research"
      }), " and get back a report with citations."]
    }), "\n", _jsx(_components.h2, {
      id: "company-intelligence",
      tabIndex: "-1",
      children: "Company intelligence"
    }), "\n", _jsx(_components.p, {
      children: "Ask chat what a company does, where it operates, who it serves, or what changed recently. Sweetspot searches the live web and pulls current information from company websites and public profiles, with source links you can check."
    }), "\n", _jsx(CompanyIntelligencePreview, {}), "\n", _jsx(_components.h2, {
      id: "people-intelligence",
      tabIndex: "-1",
      children: "People intelligence"
    }), "\n", _jsx(_components.p, {
      children: "Every pursuit has people behind it: the program lead at a teaming partner, the growth VP at a competitor, the contact you need before the industry day. Ask chat to find the people who matter and get names, roles, verified emails, and LinkedIn profiles attached. No more guessing at addresses or paying for a separate contact database."
    }), "\n", _jsx(PeopleIntelligencePreview, {}), "\n", _jsx(_components.h2, {
      id: "news-intelligence",
      tabIndex: "-1",
      children: "News intelligence"
    }), "\n", _jsx(_components.p, {
      children: "Ask what changed around a company, agency, market, person, or event. Sweetspot searches current coverage across major publications, trade press, and niche outlets, ranks the stories by relevance, and returns publication dates and source links you can check."
    }), "\n", _jsx(NewsIntelligencePreview, {}), "\n", _jsx(_components.h2, {
      id: "deep-research",
      tabIndex: "-1",
      children: "Deep Research"
    }), "\n", _jsxs(_components.p, {
      children: ["Some questions take more than a search. Hand ", _jsx(_components.strong, {
        children: "Deep Research"
      }), " any complex research task and it breaks the question into subtasks, researches each one across the live web, and writes up the answer with every claim grounded in a citation you can check. Use it for market briefs, competitor teardowns, or agency homework before a capture call. Pick it from the tool menu in any chat."]
    }), "\n", _jsx(DeepResearchPreview, {}), "\n", _jsx(_components.h2, {
      id: "how-to-start",
      tabIndex: "-1",
      children: "How to start"
    }), "\n", _jsxs(_components.p, {
      children: ["Open a chat and ask about a company you're watching, like ", _jsx(_components.em, {
        children: "\"What is Cardinal Systems focused on, and who leads business development?\""
      }), " For recent coverage, try ", _jsx(_components.em, {
        children: "\"What's changed this week in federal zero-trust policy?\""
      }), " For the deep dives, select ", _jsx(_components.strong, {
        children: "Deep Research"
      }), " from the tool menu and ask the question you'd normally assign to an analyst."]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
